import {
  Empty,
  Form,
  FormItemProps,
  Row,
  Select,
  SelectProps,
  Spin,
} from 'antd'
import './style.less'
import { CloseOutlined } from '@ant-design/icons'
import { thousandSeparator } from '@/utils/common'
import { getOrderNumbersByFilter } from '../../../Inspection.service'
import { useEffect, useRef, useState } from 'react'
import {
  debounce,
  filter,
  find,
  includes,
  isEmpty,
  isEqual,
  uniqWith,
} from 'lodash'
import { useQuery } from 'react-query'
import { useAdvanceSelectedOrderItem } from '@/jotai/inspection.jotai'

export type FORM_ITEM_ORDER_TYPE = {
  formItemProps: FormItemProps
  selectProps?: SelectProps
  isActive?: boolean
  cbDataSelected: (value: any) => void
}

const defaultInspectionFilter = {
  orderNumber: '',
  styleIds: [],
  supplierName: null,
}

export default function FormItemOrder(props: FORM_ITEM_ORDER_TYPE) {
  const { formItemProps, selectProps, isActive = false, cbDataSelected } = props

  const { getAtomSelectedOrders } = useAdvanceSelectedOrderItem()

  const orderNumSelectRef = useRef(null)

  const [orderPagination, setOrderPagination] = useState(1)
  const [orderNumberSearch, setOrderNumberSearch] = useState('')
  const [orderNumLoadMore, setOrderNumLoadMore] = useState(false)
  const [dataOrdersPagination, setDataOrdersPagination] = useState<any>({})
  const [dataOrders, setDataOrders] = useState([])
  const [inspectionFilter, setInspectionFilter] = useState(
    defaultInspectionFilter
  )

  const maxHeightOrder = 450

  const [loadingCompo, setLoadingCompo] = useState(true)

  const {} = useQuery(['ORDER_SEARCH', orderNumberSearch], async () => {
    const wrapData = {
      orderNumber: isEmpty(orderNumberSearch) ? '' : orderNumberSearch,
      styleIds: [],
      supplierName: null,
    }

    setInspectionFilter((preState) => {
      if (isEqual(preState, wrapData)) {
        return preState
      }
      preState = wrapData
      setDataOrders([])
      setOrderPagination(1)

      return preState
    })
  })

  useEffect(() => {
    setLoadingCompo(true)
    handleFilterOrderItem(() => {
      setLoadingCompo(false)
    })
  }, [orderPagination, isActive, inspectionFilter])

  const handleFilterOrderItem = async (cb) => {
    const params = {
      pageNumber: orderPagination,
      pageSize: 15,
    }
    const payload = inspectionFilter

    const response = await getOrderNumbersByFilter(params, payload, null)
    setDataOrdersPagination(response.pagination)

    setOrderNumLoadMore(false)
    if (!isEmpty(response.pagination)) {
      cb()
    }
    setDataOrders((preState) => {
      const result = [...preState, ...response.data]
      setOrderNumLoadMore(false)
      if (!isEmpty(response.pagination)) {
        cb()
      }
      return uniqWith(result, isEqual)
    })
  }

  const handleOrderNumberPagination = (event) => {
    event.persist()
    const currentTarget = event.currentTarget
    const offsetHeight = currentTarget.scrollTop + currentTarget.offsetHeight
    const scrollHeight = currentTarget.scrollHeight - 500

    if (offsetHeight >= scrollHeight) {
      if (!orderNumLoadMore) {
        setOrderNumLoadMore(true)
        setOrderPagination((preState) =>
          preState < dataOrdersPagination?.last_page ? preState + 1 : preState
        )
      }
    }
  }

  const onChangeItem = (values) => {
    const filterItem = filter(dataOrders, (item) => {
      return includes(values, item.id)
    })
    cbDataSelected(filterItem)
  }

  const onSearchOrderNumber = async (values: string) => {
    setOrderNumberSearch(values)
  }

  const handleRenderItem = (dataTag) => {
    if (isEmpty(dataTag)) {
      return <></>
    }

    const { number, total_quantity, pv_value, supplier_name } = dataTag
    const itemNumber = number
    // TODO TO ENABLE BACK AFTER
    const totalQuantity = thousandSeparator(total_quantity)
    const itemPValue = pv_value
    const itemSupplierName = supplier_name
    return (
      <>
        <div className="style-top">
          <p className="order-number">{itemNumber}</p>
          {/* <p className="normal-text">(Qty: {totalQuantity})</p> */}
        </div>

        {/* <div className="style-middle">
          <p>{itemPValue}</p>
        </div>
        <div className="style-bottom">
          <p className="normal-text">{itemSupplierName}</p>
        </div> */}
      </>
    )
  }

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectProps}
        ref={orderNumSelectRef}
        allowClear
        showSearch
        showArrow
        size="large"
        mode="multiple"
        filterOption={false}
        className="wrap-order-select"
        popupClassName="order-select-container"
        loading={loadingCompo}
        onSearch={debounce(onSearchOrderNumber, 800)}
        listHeight={maxHeightOrder}
        onBlur={() => {
          orderNumSelectRef.current.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          setOrderNumberSearch('')
        }}
        onChange={(values) => {
          onChangeItem(values)
        }}
        virtual={false}
        onPopupScroll={(event) => handleOrderNumberPagination(event)}
        notFoundContent={
          loadingCompo ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        value={getAtomSelectedOrders}
        tagRender={(tags: any) => {
          let getChildren = tags?.label?.props?.children
          if (!getChildren) {
            const item = find(getAtomSelectedOrders, (i) => i.id === tags.value)
            getChildren = handleRenderItem(item)
          }

          return (
            <Row className="tag-render" align={'middle'}>
              <div className="selected-container">
                <div className="wap-selected-content">{getChildren}</div>
                <CloseOutlined
                  className="cross-icon"
                  onClick={() => {
                    tags.onClose()
                  }}
                />
              </div>
            </Row>
          )
        }}
      >
        {dataOrders?.map((item) => {
          return (
            <Select.Option key={item.id} value={item.id}>
              <Row className="option-container">{handleRenderItem(item)}</Row>
            </Select.Option>
          )
        })}
        {loadingCompo && (
          <div style={{ backgroundColor: 'white' }}>
            <Spin size="small" />
          </div>
        )}
      </Select>
    </Form.Item>
  )
}
